<div class="login_form">

    <div class="logo">
        <!-- <img src="../../../../../assets/images/logo/ecm_logo.png"> -->
        <span>DocsFlow</span>
    </div>

    <div class="title" >CREATE AN ACCOUNT</div>

    <form name="loginForm">


        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>First Name</mat-label>
                    <input matInput  maxlength="50">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">
                    <mat-label>Last Name</mat-label>
                    <input matInput  maxlength="50">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>
            </div>
        </div>


        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" value="user@gmail.com" maxlength="50" disabled>
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">
                    <mat-label>Phone</mat-label>
                    <input matInput type="text" maxlength="50">
                    <mat-icon matSuffix class="secondary-text">call</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" maxlength="50">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput type="password"  maxlength="50">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                </mat-form-field>
            </div>
        </div>
        <button mat-flat-button color="primary" class="submit-button">  SIGN UP </button>
    </form>


  
</div>
